import React, { useState , useEffect} from 'react';
import { useNavigate , useLocation, Link} from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import GlobalNav from '../../globalComponents/GlobalNav';
import Footer from '../../globalComponents/Footer';
import Loader from '../../utils/loading/Loader';


const EMAIL_RE = /^(?!\.)(?!.*\.\.)[A-Za-z0-9._%+\-]+(?<!\.)@(?!-)(?!.*\.\.)[A-Za-z0-9.\-]+(?<!-)\.[A-Za-z]{2,}$/;

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fmessage, setFmessage] = useState('');
  const [smessage, setSmessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    // Get the email from the state
    const { state } = location;
    if (state && state.passmessage) {
      setSmessage(state.passmessage);
    } 
  }, [location, navigate]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFmessage('');
    setSmessage('');

    if (!EMAIL_RE.test(email.trim())) {
      setFmessage('Please enter a valid email address.');
      return;
    }

    try {
      setIsAuthenticating(true);
      const response = await fetch('/pceapi/auth/admin/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
        credentials: 'include', // Important for sending/receiving cookies
      });

      const data = await response.json();
  
      if (data.status === 'success') {
        navigate('/admindashboard');
      } else if (data.status === 'FORCE PASSWORD CHANGE') {
        navigate('/admin-confirm-new-password', { state: { email } });
      } else {
        setFmessage(data.message || 'An error occurred');
      }
    } catch (error) {
      setFmessage('An error occurred. Please try again.');
    }
    finally{
      setIsAuthenticating(false);
    }
  };

  
  if (isAuthenticating)
    return <div><Loader/></div>;
  
  return (
    <div className="main-window">
    <div className="container">
      <div className="auth-nav-bottom-margin">
        <GlobalNav/>
      </div>
      <div className="row m-0">
        <div className="col-lg-5 auth-main-container"> 
        <div className=""> 
          <div className="text-center">
            <span className="ev-small-p-blue ev-radius-large ev-fs-25 mb-1"><i className="bi bi-shield-lock bi-bold"></i></span>
            <p className="ev-small-p-dark ev-fs-20 ev-bold-reg mb-1"> Admin login</p>
            <p className="ev-message-card1 mb-4">BMS IAM administration management</p>
          </div>
            <form onSubmit={handleSubmit}>
              <p className="ev-reg-p-dark mb-1">Email</p>
              <input className="formField1 margin-bottom-5" id="email-address" name="email" type="email" autoComplete="email" required placeholder="E.g. john@bms.com" value={email} onChange={(e) => setEmail(e.target.value)}/>

              <p className="ev-reg-p-dark mb-1">Password</p>
              <input className="formField1 mb-0 pe-5" id="password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" required placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)}/>
              
              <div className="text-end eye-mask-password">
              <button type="button" className="ev-fs-10 ev-btn-xsmall ev-btn-text-only-fill" onClick={togglePasswordVisibility}>
                {showPassword ? (
                  <EyeOff  />
                ) : (
                  <Eye />
                )}
              </button>
              </div>
              <button type="submit" className="ev-btn-blue-fill-round ev-fs-15 ev-bold-reg w-100 ev-padding-small">Log in</button>
            </form>

            <div className="text-end mt-1">
              <Link to="/admin-forgot-password" className="text-decoration-none ev-fs-14 ev-bold-reg ev-link-accent">Forgot password?</Link>
            </div>
            {fmessage && (
          <div className="mt-3 alert alert-danger">
            {fmessage}
          </div>
           )}

          {smessage && (
          <div className="mt-3 alert alert-success">
            {smessage}
          </div>
           )}
        </div>
          </div>
      </div>
    </div>
    <Footer/>
    </div>
  );
};

export default AdminLogin;